import React, { Suspense, lazy, useState } from "react";
import "./HomePage.css";
import HeroSection from "../components/Hero/HeroSection";
import EmailSubscription from "../components/EmailSubscription/EmailSubscription";

const TrendingSection = lazy(() => import("../components/TrendingSection/TrendingSection"));
const ExpertInsights = lazy(() => import("../components/ExpertInsights/ExpertInsights"));
const LatestNews = lazy(() => import("../components/LatestNews/LatestNews"));
const OpinionsSection = lazy(() => import("../components/Opinions/OpinionsSection"));
const RecommendationsSection = lazy(() =>
  import("../components/RecommendationsSection/RecommendationsSection")
);

const GuestBanner = () => {
  const isGuest = !localStorage.getItem("token");
  const [visible, setVisible] = useState(isGuest);

  if (!visible) return null;

  return (
    <div className="hp-guest-banner">
      <div className="hp-guest-banner-inner">
        <span className="hp-guest-banner-icon">🔓</span>
        <div className="hp-guest-banner-copy">
          <strong>Unlock full platform access. It's free.</strong>
          <span> Threat globe, actor profiles, IoC validation, breach feeds and more.</span>
        </div>
        <a href="/signup" className="hp-guest-banner-cta">Create Free Account →</a>
        <button
          className="hp-guest-banner-close"
          aria-label="Dismiss"
          onClick={() => setVisible(false)}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

const SectionSkeleton = ({ rows = 3, variant = "card" }) => (
  <div className={`hp-skeleton hp-skeleton--${variant}`} aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="hp-skel" />
    ))}
  </div>
);

const HomePage = () => {
  const [sections, setSections] = useState({
    trending: true,
    expertInsights: true,
    opinions: true,
    recommendations: true,
    latestNews: true,
  });

  const toggleSection = (key) => setSections((s) => ({ ...s, [key]: !s[key] }));

  return (
    <div className="home-page">
      <GuestBanner />
      <HeroSection />
      <div className="divider" />

      <div className="main-content">
        {/* LEFT: Trending + Expert */}
        <div className="left-content">
          <section>
            <h2
              className="section-header"
              onClick={() => toggleSection("trending")}
              title="Toggle Trending Now"
            >
              Trending Now
            </h2>

            {sections.trending && (
              <Suspense fallback={<SectionSkeleton rows={3} variant="card" />}>
                <TrendingSection />
              </Suspense>
            )}
          </section>

          <div className="divider" />

          <section>
            <h2
              className="section-header"
              onClick={() => toggleSection("expertInsights")}
              title="Toggle Expert Insights"
            >
              Expert Insights
            </h2>

            {sections.expertInsights && (
              <Suspense fallback={<SectionSkeleton rows={3} variant="card" />}>
                <ExpertInsights />
              </Suspense>
            )}
          </section>
        </div>

        {/* RIGHT: Latest News */}
        <aside className="right-content">
          <section className="aside-card">
            <h2
              className="section-header"
              onClick={() => toggleSection("latestNews")}
              title="Toggle Latest News"
            >
              Latest News
            </h2>

            {sections.latestNews && (
              <Suspense fallback={<SectionSkeleton rows={5} variant="list" />}>
                <LatestNews hideHeader={true} />
              </Suspense>
            )}
          </section>
        </aside>
      </div>

      <div className="divider" />

      <section>
        <h2
          className="section-header"
          onClick={() => toggleSection("opinions")}
          title="Toggle Opinions"
        >
          Opinions
        </h2>

        {sections.opinions && (
          <Suspense fallback={<SectionSkeleton rows={3} variant="card" />}>
            <OpinionsSection />
          </Suspense>
        )}
      </section>

      <div className="divider" />

      <section>
        <h2
          className="section-header"
          onClick={() => toggleSection("recommendations")}
          title="Toggle Recommendations"
        >
          Recommendations
        </h2>

        {sections.recommendations && (
          <Suspense fallback={<SectionSkeleton rows={3} variant="card" />}>
            <RecommendationsSection />
          </Suspense>
        )}
      </section>

      <EmailSubscription />
    </div>
  );
};

export default HomePage;
